// removed by extract-text-webpack-plugin
module.exports = {"listContainer":"src-components-PatientGroups-GroupsMenu-__styles__listContainer--1-Kpx","title":"src-components-PatientGroups-GroupsMenu-__styles__title--1X-PG","list":"src-components-PatientGroups-GroupsMenu-__styles__list--36ioe","listItem":"src-components-PatientGroups-GroupsMenu-__styles__listItem--2kKYo","selectedListItem":"src-components-PatientGroups-GroupsMenu-__styles__selectedListItem--2tGFg src-components-PatientGroups-GroupsMenu-__styles__listItem--2kKYo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientGroups/GroupsMenu/styles.css
// module id = 777
// module chunks = 0